export default "__VITE_ASSET__CJmq$irG__"